import {
  DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_BEGIN,
  DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_SUCCESS,
  DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_FAILURE,
  DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function updateTableAndFieldsForXata(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xata/update-table`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_SUCCESS,
            data: res.data,
          });
          console.log('request success ', res.data);
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_FAILURE,
            data: { error: err },
          });
          console.log('errr', err);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateTableAndFieldsForXataError() {
  return {
    type: DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_BEGIN:
      return {
        ...state,
        updateTableAndFieldsForXataPending: true,
        updateTableAndFieldsForXataError: null,
      };

    case DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_SUCCESS:
      return {
        ...state,
        updateTableAndFieldsForXataPending: false,
        updateTableAndFieldsForXataError: null,
      };

    case DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_FAILURE:
      return {
        ...state,
        updateTableAndFieldsForXataPending: false,
        updateTableAndFieldsForXataError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_TABLE_AND_FIELDS_FOR_XATA_DISMISS_ERROR:
      return {
        ...state,
        updateTableAndFieldsForXataError: null,
      };

    default:
      return state;
  }
}
